<div class="header">
  <div class="header__left">
    <div class="img-plc g-cursor-pointer" routerLink="/{{loginUrl}}">
      <img alt="" src="{{logo}}"/>
    </div>
  </div>
  <div class="header__right">
    <button class="accr-apply" matTooltip="Apply for accreditation of your facility"
            routerLink="/{{accreditationApplication}}">Apply for accreditation
    </button>
    <button mat-stroked-button routerLink="/{{loginUrl}}">Log in</button>
  </div>
</div>
